import { fetchGet } from './api';
import { ISituation } from '../types/situation.type';

export const fetchSituations = () => fetchGet<ISituation[]>('situations');
